<template>
  <v-app class="disable-favorites">
    <router-view />
    <err-dialog />
  </v-app>
</template>

<script>
import dialog from "./dialog.vue";
import "moodleDir/procollege/lib/style/styleTabs.css";
export default {
  name: "App",
  components: {
    "err-dialog": dialog,
  },
  created() {},
};
</script>
<style lang="scss">
#procollege_vue,.v-overlay-container {
  .v-application--wrap {
    min-height: 100px !important;
  }
  /**
  secondary-navigation 60px default, даже если пустая
  */
  .moremenu {
    height: auto;
  }
  /**
  * цвет текста у кнопок/списков, etc перебивает тема moodle, в vuetify 4 !important
  * больше не используется
  */
  .v-btn.bg-primary {
    background-color: rgb(var(--v-theme-primary)) !important;
    color: rgb(var(--v-theme-on-primary)) !important;
  }

  .text-primary {
    color: rgb(var(--v-theme-primary)) !important;
  }
  .text-secondary {
    color: rgb(var(--v-theme-secondary)) !important;
  }
  .text-success {
    color: rgb(var(--v-theme-success)) !important;
  }
  .text-warning {
    color: rgb(var(--v-theme-warning)) !important;
  }
  .text-error {
    color: rgb(var(--v-theme-error)) !important;
  }
  .text-info {
    color: rgb(var(--v-theme-info)) !important;
  }
  /**
  bg-colors
   */
  .bg-warning{
    background-color:rgba(var(--v-theme-warning)) !important
  }

  //попытка выровнять текст чекбоксов и радиокнопок относительно контрола
  .v-selection-control--density-default,.v-selection-control--density-compact{
    --v-selection-control-size: 28px;
    --v-input-control-height: 28px;
  }
  //иконка календаря к правому краю инпута
  .text-field-date-icon input[type="date"] {
    padding-right: 44px;
    position: relative;
  }

  .text-field-date-icon input[type="date"]::-webkit-calendar-picker-indicator {
    cursor: pointer;
    height: 20px;
    margin: 0;
    position: absolute;
    right: 10px;
    width: 20px;
  }
}
</style>
